module.exports = __webpack_public_path__ + "img/footer_qr_douyin.9d94c7e0.jpg";